import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto px-4 py-8 min-h-screen" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { class: "text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 break-words" }
const _hoisted_4 = { class: "text-[#157813] block sm:inline mt-2 sm:mt-0" }
const _hoisted_5 = {
  key: 0,
  class: "w-full"
}
const _hoisted_6 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" }
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col items-center justify-center space-y-4 min-h-[50vh]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QueryCard = _resolveComponent("QueryCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.feature), 1)
      ])
    ]),
    (_ctx.filteredQueries.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredQueries, (query) => {
              return (_openBlock(), _createElementBlock("div", {
                key: query.id,
                class: "w-full"
              }, [
                _createVNode(_component_QueryCard, {
                  query: query,
                  onClick: ($event: any) => (_ctx.showQueryDetails(query.id)),
                  class: "h-full transition-transform duration-300 hover:scale-105"
                }, null, 8, ["query", "onClick"])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-gray-500 text-lg md:text-xl font-medium text-center uppercase" }, " No queries found for this feature ", -1)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
            class: "px-6 py-2 bg-[#157813] text-white rounded-lg hover:bg-[#1a8f17] transition-colors duration-300"
          }, " Back to Home ")
        ]))
  ]))
}